import { request } from '../utils/httpClient';
import {
  LoginResponse,
  Credentials,
  PasswordResetRequest,
  PasswordResetResponse,
  PasswordResetConfirm,
  PasswordResetComplete,
} from '../types/auth';

export const login = (data: Credentials): Promise<LoginResponse> =>
  request({
    url: '/login',
    method: 'POST',
    data,
  });

export const logout = (): Promise<void> =>
  request({
    url: '/logout',
    method: 'POST',
    data: { refresh_token: localStorage.getItem('refresh') },
  });

export const getMe = (): Promise<any> =>
  request({
    url: '/refresh',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('refresh')}`,
    },
  });

export const getForgotPassword = (
  data: PasswordResetRequest
): Promise<PasswordResetResponse> =>
  request({
    url: '/password-reset/request',
    method: 'POST',
    data,
  });

export const getResetPassword = (data: PasswordResetConfirm): Promise<any> =>
  request({
    url: '/password-reset/confirm?token=' + data.token,
    method: 'GET',
  });

export const updatePassword = (
  data: PasswordResetComplete
): Promise<PasswordResetResponse> =>
  request({
    url: '/password-reset/complete',
    method: 'POST',
    data,
  });
